/** First/last sibling memo hooks for task hierarchy connectors. */
import { useMemo } from 'react';
import {
  isFirstSiblingInFlatList,
  isLastSiblingInFlatList,
} from '@/features/tasks/hooks/ui/use-task-hierarchy.helpers';

export function useSiblingConnectorFlags({
  index,
  tasks,
  displayLevel,
  indentationType,
  isExecutionView,
}) {
  const isFirstSubtask = useMemo(() => {
    if (displayLevel === 0) return false;
    if (!tasks?.length) return false;

    return isFirstSiblingInFlatList(
      tasks,
      index,
      displayLevel,
      indentationType,
      isExecutionView,
    );
  }, [index, displayLevel, tasks, indentationType, isExecutionView]);

  const isLastSubtask = useMemo(() => {
    if (displayLevel === 0) return false;
    if (!tasks?.length) return false;

    return isLastSiblingInFlatList(
      tasks,
      index,
      displayLevel,
      indentationType,
      isExecutionView,
    );
  }, [index, displayLevel, tasks, indentationType, isExecutionView]);

  return { isFirstSubtask, isLastSubtask };
}
